import React from 'react'
import '../styles/Subsidio.css'

const Subsidio = () => {
  return (
    <main className="subsidio-cont">
        <h1>
            Subsidios
        </h1>
        <h3>
            Subsidios por fallecimiento
        </h3>

        <p>
        Producido el fallecimiento del asociado adherido, ante la presentación de la Partida de Defunción en la Secretaría de la Asociación, se procederá a la apertura del sobre que contiene la «Declaración de Beneficiarios». El o los beneficiarios designados, percibirán el importe conforme con la cápita acordada en su oportunidad
        </p>
   
    </main>
  )
}

export default Subsidio